<script setup>
import { nextTick } from "vue";
import bootstrap from "bootstrap/dist/js/bootstrap.min.js";

const props = defineProps({
  url: { type: String, required: true },
  label: { type: String, default: "" },
});

const emit = defineEmits(["view"]);

const vOverflowTooltip = {
  mounted(el, binding) {
    nextTick(() => {
      if (el.scrollWidth > el.clientWidth) {
        el.__tip = new bootstrap.Tooltip(el, { title: binding.value, placement: "top", trigger: "hover" });
      }
    });
  },
  updated(el, binding) {
    nextTick(() => {
      if (el.scrollWidth > el.clientWidth) {
        if (el.__tip) {
          el.__tip._config.title = binding.value;
        } else {
          el.__tip = new bootstrap.Tooltip(el, { title: binding.value, placement: "top", trigger: "hover" });
        }
      } else if (el.__tip) {
        el.__tip.dispose();
        el.__tip = null;
      }
    });
  },
  unmounted(el) {
    try { el.__tip?.dispose(); } catch { /* ignore */ }
    el.__tip = null;
  },
};

function getCleanFileName(url) {
  const value = String(url || "").trim();
  if (!value) return "documento";
  const withoutQuery = value.split("?")[0];
  const chunks = withoutQuery.split("/");
  return decodeURIComponent(chunks[chunks.length - 1]) || "documento";
}

function download() {
  const fileName = getCleanFileName(props.url);
  const link = document.createElement("a");
  link.href = props.url;
  link.setAttribute("download", fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
</script>

<template>
  <div class="view-image-card">
    <div class="view-image-img">
      <img :src="url" :alt="label" />
      <div class="view-image-hover">
        <button v-tooltip="'Ver'" class="view-image-action" @click.stop="emit('view')">
          <i class="fas fa-expand-alt"></i>
        </button>
        <button v-tooltip="'Descargar'" class="view-image-action" @click.stop="download()">
          <i class="fas fa-download"></i>
        </button>
      </div>
    </div>
    <div v-overflow-tooltip="label" class="view-image-label text-xs">
      {{ label }}
    </div>
  </div>
</template>

<style scoped>
.view-image-card {
  width: 150px;
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid #dee2e6;
  transition: box-shadow 0.15s, transform 0.15s;
  background: #f8f9fa;
}

.view-image-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-1px);
}

.view-image-img {
  position: relative;
  aspect-ratio: 1;
  overflow: hidden;
}

.view-image-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.view-image-hover {
  position: absolute;
  top: 0.4rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 0.35rem;
  opacity: 0;
  transition: opacity 0.15s;
}

.view-image-card:hover .view-image-hover {
  opacity: 1;
}

.view-image-action {
  background: rgba(0, 0, 0, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 50%;
  color: #fff;
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s;
}

.view-image-action:hover {
  background: rgba(255, 255, 255, 0.35);
}

.view-image-label {
  padding: 0.3rem 0.6rem;
  background: white;
  color: #495057;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-top: 1px solid #dee2e6;
}
</style>
